import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { Rings } from "react-loader-spinner";
import "./spinner.css";

export const Spinner = (props) => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        promiseInProgress && (
            <div className="spinner">
                <Rings color="#2BAD60" height="100" width="100" />
            </div>
        )
    );
};

